// extracted by mini-css-extract-plugin
export default {"section":"HomePage_section__hy8KC","sectionHeader":"HomePage_sectionHeader__ADH9k","linkButton":"HomePage_linkButton__qiNiX","page":"HomePage_page__wB5Tu"};